<template>
    <div v-if="show" class="modal-detail" style="text-align: left">
        <el-dialog :visible.sync="show" :title="name" width="900px">
            <template v-slot>
                <el-form ref="form" size="small" :model="data" label-width="auto" label-position="right" :rules="rules">
                    <el-form-item label="代码" prop="extSettings">
                        <codemirror ref="cmExpressionsRef" v-model="data.extSettings" :options="cmOptions"></codemirror>
                    </el-form-item>
                </el-form>
            </template>
            <template slot="footer">
                <div style="text-align: center">
                    <el-button type="primary" style="width: 100%" @click="save" :loading="loading">确定</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import 'codemirror/mode/javascript/javascript'
import 'codemirror/theme/monokai.css'
import 'codemirror/addon/edit/closebrackets.js'
import 'codemirror/mode/clike/clike.js'
import 'codemirror/lib/codemirror.css'

export default {
    name: "formConfig.vue",
    data() {
        return {
            cmOptions: {
                mode: {
                    name: 'javascript',
                    json: true
                },
                theme: 'monokai',
                tableSize: 4,
                autofocus: true,
                lineNumbers: true, //显示行号
                smartIndent: true, // 自动缩进
                autoCloseBrackets: true, // 自动补全括号
            },
            data: {},
            name: '',
            loading: false,
            show: false,
            type: '',
            rules: {
                extSettings: {
                    required: true,
                    trigger: 'blur',
                    message: '请输入代码'
                }
            }
        }
    },
    methods: {
        display(data) {
            this.show = true
            this.data = data.data
            setTimeout(() => {
                this.$refs.cmExpressionsRef.codemirror.refresh()
            }, 50)
            this.type = data.type
            this.name = data.name
        },
        save() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.loading = true
                    try {
                        eval('(function (){ ' + this.data.extSettings + '}())');
                    } catch (e) {
                        console.log(e);
                        this.$message.error('所写代码有误');
                        this.loading = false
                        return;
                    }
                    let data
                    if (this.type === 'form') {
                        data = {
                            formCreate: this.data.extSettings,
                            id: this.data.id
                        }
                    } else if (this.type === 'headerButton') {
                        data = {
                            headerButton: this.data.extSettings,
                            id: this.data.id
                        }
                    } else if (this.type === 'lineButton') {
                        data = {
                            lineButton: this.data.extSettings,
                            id: this.data.id
                        }
                    } else if (this.type === 'footerButton') {
                        data = {
                            footerButton: this.data.extSettings,
                            id: this.data.id
                        }
                    }
                    this.$axios.post('/query/basicsModel/edit', data).then(() => {
                        this.$message.success(`修改成功`)
                        this.show = false
                        this.$emit('init')
                        this.loading = false
                    }).catch(err => {
                        console.log(`修改失败`, err)
                        this.loading = false
                    })
                } else {
                    return false
                }
            })
        }
    }
}
</script>
